var map = {
	"./arrow-left.svg": "c36d",
	"./arrow-right.svg": "a584",
	"./cadooz-logo.svg": "e506",
	"./caret-down-fill.svg": "da6c",
	"./cart3.svg": "7c74",
	"./catIcon10.svg": "0164",
	"./catIcon13093.svg": "dd77",
	"./catIcon14.svg": "9dc6",
	"./catIcon15.svg": "b114",
	"./catIcon297.svg": "68e4",
	"./catIcon332.svg": "e137",
	"./catIcon339.svg": "7c2b",
	"./catIcon5.svg": "990b",
	"./catIcon6.svg": "5bd9",
	"./catIcon689.svg": "10bb",
	"./catIcon8.svg": "d2a0",
	"./catIcon9.svg": "c517",
	"./catIconDefault.svg": "8662",
	"./chevron-right.svg": "9ee6",
	"./credit-card.svg": "d0d6",
	"./dropdown-down.svg": "6f4d",
	"./exclamation-triangle.svg": "fb1e",
	"./flags/de.svg": "83dda",
	"./flags/en.svg": "116e",
	"./flags/es.svg": "5c7e",
	"./flags/fr.svg": "7b4b",
	"./flags/it.svg": "5652",
	"./flags/nl.svg": "7d15",
	"./flags/pl.svg": "6ad4",
	"./forgot-password-icon.svg": "0ca4",
	"./gear-fill.svg": "8c14",
	"./hide-password-icon.svg": "805a",
	"./laptop.svg": "a24a",
	"./left-arrow.svg": "b8f0",
	"./list.svg": "875e",
	"./logout.svg": "b29c",
	"./password-check.svg": "247e",
	"./person.svg": "d8ad",
	"./phone.svg": "ce05",
	"./printer.svg": "3049",
	"./right-arrow.svg": "c737",
	"./search.svg": "9208",
	"./shop.svg": "6a7b",
	"./show-password-icon.svg": "b0de",
	"./trustpilotIcon.svg": "a022",
	"./x.svg": "da77"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";